/**
 * The identifier shown on a certification record.
 *
 * The certifier's own registration code (`UltraGreen reg. string`, e.g.
 * `BUB-003-260722`) is what a reader can quote back to UltraGreen, so it wins
 * whenever the product carries one. Most certified products do not, and for
 * those the authId — the code the QR itself encodes — is still a real handle
 * on the record, so it is the fallback rather than an empty field.
 *
 * The API returns the two separately on purpose: a response that substituted
 * one for the other could not be told apart from a product genuinely
 * registered under its authId.
 *
 * This is display only. Anything the backend keys on — the complaint form's
 * `productAuthId`, the URL — keeps using `authId`.
 */
export default function recordId(product) {
  if (!product) return "";
  const reg = product.regString;
  if (typeof reg === "string" && reg.trim()) return reg.trim();
  return product.authId || "";
}
